import { render, staticRenderFns } from "./app-document-not-ready.vue?vue&type=template&id=247bc4cf&"
import script from "./app-document-not-ready.vue?vue&type=script&lang=js&"
export * from "./app-document-not-ready.vue?vue&type=script&lang=js&"
import style0 from "./app-document-not-ready.vue?vue&type=style&index=0&id=247bc4cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports